// material
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  CircularProgress,
  Button,
  Pagination,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';
import { useMemo, useState } from 'react';
import { format } from 'date-fns';
import { omitBy } from 'lodash';
import FileDownload from 'js-file-download';
import SearchIcon from '@mui/icons-material/Search';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import { UserListHead } from '../sections/@dashboard/user';
import { Search, SearchIconWrapper, StyledInputBase } from '../components/SearchInput';

// store
import { api as stockApi } from '../store/domains/stock';

const TABLE_HEAD = [
  { id: 'created_at', label: 'Created', alignRight: false },
  { id: 'seller_name', label: 'Seller Name', alignRight: false },
  { id: 'mobile_number', label: 'Mobile Number', alignRight: false },
  { id: 'pin', label: 'Pin Number', alignRight: false },
  { id: 'recognitionType', label: 'Recognition Type', alignRight: false },
  { id: 'Contract', label: 'Contract', alignRight: false },
];

const MySwal = withReactContent(Swal);

export default function Dealer() {
  const [contractLanguage, setContractLanguage] = useState('AZ');
  const [page, setPage] = useState(1);
  const [search, setSearchValue] = useState('');
  const params = useMemo(() => omitBy({ search, page }, (v) => v.toString().length < 1), [search, page]);
  const { data, isLoading } = stockApi.useGetTransactionHistory(params);
  const [downloadContract, { isLoading: contractLoading }] = stockApi.useGetDownloadContract();

  const handleDownloadContract = async (values) => {
    const { trackId, mobile_number: number, pin } = values;

    const params = {
      trackId,
      referrer: 2,
      language: contractLanguage,
    };
    try {
      const response = await downloadContract(params).unwrap();
      FileDownload(response, `${number}.pdf`);
    } catch (error) {
      params.pinCode = pin;
      try {
        const response = await downloadContract(params).unwrap();
        FileDownload(response, `${number}.pdf`);
      } catch (error) {
        MySwal.fire({
          title: <p>{error}</p>,
          icon: 'error',
        });
      }
    }
  };

  const handleChangeSearchInput = (event) => {
    setSearchValue(event.target.value);
  };
  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <Page title="User">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={3}
            sx={{ my: 2, width: '100%' }}
          >
            <Search>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                onChange={handleChangeSearchInput}
                value={search}
                placeholder="Search…"
                inputProps={{ 'aria-label': 'search' }}
              />
            </Search>
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label">Contract language</FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                value={contractLanguage}
                onChange={(event) => setContractLanguage(event.target.value)}
                name="radio-buttons-group"
              >
                <FormControlLabel value="AZ" control={<Radio />} label="AZ" />
                <FormControlLabel value="EN" control={<Radio />} label="EN" />
              </RadioGroup>
            </FormControl>
          </Stack>
        </Stack>
        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead headLabel={TABLE_HEAD} rowCount={data?.data?.length} />
                <TableBody>
                  {data?.data?.map((row, index) => (
                    <TableRow hover key={index} tabIndex={-1}>
                      <TableCell align="left">{index + 1}</TableCell>
                      <TableCell align="left">{format(new Date(row.created_at), 'MM.dd.yyyy HH:mm')}</TableCell>
                      <TableCell align="left">{row.user.seller_name}</TableCell>
                      <TableCell align="left">{row.mobile_number}</TableCell>
                      <TableCell align="left">{row.pin}</TableCell>
                      <TableCell align="left">{row.recognitionType}</TableCell>
                      <TableCell align="left">
                        <Button
                          sx={{
                            marginLeft: '-1rem',
                          }}
                          variant="contained"
                          onClick={() => handleDownloadContract(row, row.pinForContract)}
                          disabled={contractLoading}
                        >
                          Download
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
        </Card>
        <Stack padding={2} spacing={2} justifyContent="center">
          {data?.metadata?.pagination?.total_page > 1 && (
            <Pagination
              sx={{
                display: 'flex',
                justifyContent: 'center',
              }}
              count={data?.metadata?.pagination?.total_page}
              color="primary"
              onChange={(_, val) => setPage(val)}
            />
          )}
        </Stack>
      </Container>
    </Page>
  );
}
